import React from 'react';
import { Modal, Space } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const DeleteMetadataDialog = ({ open, metadata, onClose, onConfirm }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={() => onConfirm(metadata.id)}
      title="Delete Metadata"
      okText="Delete"
      okButtonProps={{ danger: true }}
      cancelText="Cancel"
    >
      <Space>
        <ExclamationCircleOutlined style={{ color: '#faad14', fontSize: '22px' }} />
        <span>
          Are you sure you want to delete the metadata for "{metadata.field_label}"?
        </span>
      </Space>
    </Modal>
  );
};

export default DeleteMetadataDialog;
